export default __webpack_public_path__ + "assets/images/listen-icon1-3398a7c1.svg";